import { CheckCircle2, Clock, AlertCircle, Users, TrendingUp, Target } from 'lucide-react';
import { useApp } from '../../context/AppContext';

interface StatItem {
  label: string;
  value: number;
  icon: React.ElementType;
  color: string;
  bgColor: string;
  change?: string;
}

export default function StatsGrid() {
  const { state } = useApp();

  const totalTasks = state.tasks.length;
  const inProgress = state.tasks.filter((t) => t.status === 'in_progress').length;
  const completed = state.tasks.filter((t) => t.status === 'done').length;
  const overdue = state.tasks.filter((t) => {
    if (!t.dueDate || t.status === 'done') return false;
    return new Date(t.dueDate) < new Date();
  }).length;
  const activeUsers = state.users.filter((u) => u.isOnline).length;
  const totalPoints = state.tasks.reduce((sum, t) => sum + t.storyPoints, 0);

  const stats: StatItem[] = [
    {
      label: 'Total de Tarefas',
      value: totalTasks,
      icon: Target,
      color: 'text-brand-600',
      bgColor: 'bg-brand-50',
      change: '+12%',
    },
    {
      label: 'Em Progresso',
      value: inProgress,
      icon: Clock,
      color: 'text-amber-600',
      bgColor: 'bg-amber-50',
    },
    {
      label: 'Concluídas',
      value: completed,
      icon: CheckCircle2,
      color: 'text-emerald-600',
      bgColor: 'bg-emerald-50',
      change: '+8%',
    },
    {
      label: 'Atrasadas',
      value: overdue,
      icon: AlertCircle,
      color: 'text-red-600',
      bgColor: 'bg-red-50',
    }/*,
    {
      label: 'Usuários Ativos',
      value: activeUsers,
      icon: Users,
      color: 'text-cyan-600',
      bgColor: 'bg-cyan-50',
    },
    {
      label: 'Story Points',
      value: totalPoints,
      icon: TrendingUp,
      color: 'text-brand-600',
      bgColor: 'bg-brand-50',
    },*/
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
      {stats.map((stat, index) => (
        <div
          key={stat.label}
          className="bg-white rounded-2xl border border-slate-200 p-4 hover:shadow-md hover:border-brand-200 transition-all duration-300 animate-slide-in-up"
          style={{ animationDelay: `${index * 50}ms` }}
        >
          <div className="flex items-center justify-between mb-3">
            <div className={`w-9 h-9 rounded-xl ${stat.bgColor} flex items-center justify-center`}>
              <stat.icon size={18} className={stat.color} />
            </div>
            {stat.change && (
              <span className="text-[10px] font-semibold text-emerald-600 bg-emerald-50 px-1.5 py-0.5 rounded-md">
                {stat.change}
              </span>
            )}
          </div>
          <p className="text-2xl font-bold text-slate-800">{stat.value}</p>
          <p className="text-xs text-slate-500 mt-0.5">{stat.label}</p>
        </div>
      ))}
    </div>
  );
}
